module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Major Characters in the Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation"
  }, [_vm._v("In Washington")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Edward Montoya Jason of California, President of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("William Abbott, ex-President of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Mrs. Beth Knox, widow of the Secretary of State")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Representative Harold Knox, their son")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Robert A. Leffingwell, Secretary of State")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Ewan MacDonald MacDonald, Secretary of Defense")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("George Henry Wattersill, Attorney General")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Fred Van Ackerman, Senator from Wyoming, Chairman of the Committee on Making Further Efforts for a Russian Truce (COMFORT)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("LeGage Shelby, Chairman of the Defenders of Equality for You (DEFY)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Rufus Kleinfert, Chairman of the Konference on Efforts to Encourage Patriotism (KEEP)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Mr. Justice Thomas Buckmaster Davis of the Supreme Court")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Patsy Jason Labaiya, sister of the President")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Robert Durham Munson, Senator from Michigan")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Dolly, his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Tom August, Senator from Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Arly Richardson, Senator from Arkansas, Majority Leader of the United States Senate")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Representative J. B. “Jawbone” Swarthman of South Carolina, Speaker of the House")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Representative Bronson Bernard of New York")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Roger P. Croy of Oregon, Vice President of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Lafe Smith, Senator from Iowa")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Mabel Anderson, widow of Senator Brigham Anderson")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Cullee Hamilton, Senator from California")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Lady Maudulayne")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Celestine Barre")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Walter Dobius, a columnist")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Frankly Unctuous, a commentator")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Other members of the media")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Members of NAWAC (the National Anti-War Activities Congress)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation"
  }, [_vm._v("At the United Nations")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Lord Claude Maudulayne, the British Ambassador")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Raoul Barre, the French Ambassador")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Krishna Khaleel, the Ambassador of India")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Nicolai Zworkyan, Ambassador of the U.S.S.R.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation"
  }, [_vm._v("In Moscow and Washington")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Vasily Tashikov, Chairman of the Council of Ministers, U.S.S.R.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 75
// module chunks = 0